<div class="overlay" (click)="closePopup(false)"></div>
<section class="popup-container" [ngClass]="chromeExtConfigPopupExpanded ? 'popup-height' : ''">
  <h2>
    <mat-icon fontIcon="settings"></mat-icon>
    Edit Docusign Config
  </h2>
  <app-edit-config
    [emailBody]="emailBody"
    [emailSubject]="emailSubject"
    [eFormGroup]="formGroup"
    [recipientInfoService]="recipientInfoService"
    [namespace]="namespace"
    [recipients]="recipients"
    [provider]="provider"
    [usingDocusignTemplate]="usingDocusignTemplate"
    >
  </app-edit-config>
  <button theme="bare-button" (click)="closePopup(false)" [matTooltip]="'Any changes will be included'" matTooltipShowDelay="500">
    Continue <mat-icon fontIcon="navigate_next"></mat-icon>
  </button>
</section>
@if (!chromeExtConfigPopupExpanded) {
  <div class="triangle-down"></div>
}
